import { api } from '../utils/apiClient';

export interface HistoryImportResult {
  status: 'imported';
  records_imported: number;
  records_rejected: number;
  first_execution_at: string | null;
  last_execution_at: string | null;
  errors: Array<{ index: number; error: string }>;
}

export interface HistorySummary {
  status: 'empty' | 'imported';
  records_imported: number;
  first_execution_at: string | null;
  last_execution_at: string | null;
}

export const fetchFunctionalHistorySummary = async (
  projectId: string
): Promise<HistorySummary> =>
  api.get<HistorySummary>(
    `/functional/history/summary?project_id=${encodeURIComponent(projectId)}`
  );

export const fetchChaosHistorySummary = async (
  projectId: string
): Promise<HistorySummary> =>
  api.get<HistorySummary>(
    `/chaos/history/summary?project_id=${encodeURIComponent(projectId)}`
  );

export const importFunctionalHistory = async (
  projectId: string,
  records: unknown[]
): Promise<HistoryImportResult> =>
  api.post<HistoryImportResult>('/functional/history/import', {
    project_id: projectId,
    records,
  });

export const importChaosHistory = async (
  projectId: string,
  records: unknown[]
): Promise<HistoryImportResult> =>
  api.post<HistoryImportResult>('/chaos/history/import', {
    project_id: projectId,
    records,
  });

export const downloadFunctionalHistorySample = async (): Promise<unknown[]> =>
  api.get<unknown[]>('/functional/history/sample');

export const downloadChaosHistorySample = async (): Promise<unknown[]> =>
  api.get<unknown[]>('/chaos/history/sample');

export const generateSampleFunctionalHistory = async (
  projectId: string
) =>
  api.post('/functional/results/generate-history', {
    project_id: projectId,
    days: 30,
    min_sessions_per_day: 2,
    max_sessions_per_day: 4,
    seed: 7,
  });
